import { v4 as uuidv4 } from 'uuid';
// import { useRouter } from 'next/router';
import moment from 'moment';

export const clickStream = (data: any) => {
  // event_id, personal_number, device, device_type, event, event action, event category, event label, event ga, timestamp, url, version, location, product
  const datas = {
    event_id: uuidv4(),
    personal_number:
      typeof window !== undefined
        ? JSON.parse(String(localStorage.getItem('data')))?.pernr !== undefined
          ? JSON.parse(String(localStorage.getItem('data')))?.pernr
          : '-'
        : '-',
    device: data.device,
    device_type: data.device_type,
    event: data.event,
    event_action: data.event_action,
    event_category: data.event_category,
    event_label: data.event_label,
    event_ga: data.event_ga,
    timestamp: moment().format('MM-DD-YYYY, hh:mm:ss'),
    url: window.location.href,
    version: data.version,
    product: data.product,
    location: data.location,
  };
  return datas;
};